module.exports = __webpack_public_path__ + "img/kuangjiao_yj_xuwenli.7df3ccf7.jpg";